import React from 'react';
import { Link } from 'react-router-dom';

function JoinPartnerBanner() {
    const icons = [
        { icon: '🤝', label1: 'Mutual', label2: 'Growth' },
        { icon: '📈', label1: 'Business', label2: 'Expansion' },
        { icon: '🛡️', label1: 'Trusted', label2: 'Partnership' },
        { icon: '👥', label1: 'Long Term', label2: 'Success' },
    ];

    return (
        <div style={{ padding: '30px 40px', backgroundColor: '#f9f9ff' }}>
            <div style={{
                backgroundImage: "url('/img/about/join-partner.png')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100%',
                minHeight: '420px',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                borderRadius: '20px',
                overflow: 'hidden',
            }}>
                {/* Dark overlay */}
                <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(10, 15, 50, 0.65)' }} />

                <div style={{
                    position: 'relative', zIndex: 1, width: '100%', maxWidth: '1200px',
                    margin: '0 auto', padding: '60px 30px 40px',
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', flexWrap: 'wrap', gap: '40px',
                }}>
                    {/* Left Side */}
                    <div style={{ flex: '1', minWidth: '280px' }}>
                        <h1 style={{ color: '#fff', fontSize: '42px', fontWeight: '700', margin: '0 0 4px' }}>Join Us</h1>
                        <h2 style={{ color: '#7b5ff5', fontSize: '42px', fontWeight: '700', margin: '0 0 12px' }}>As Partner</h2>
                        <div style={{ width: '60px', height: '3px', backgroundColor: '#7b5ff5', marginBottom: '20px' }} />
                        <p style={{ color: '#ddd', fontSize: '16px', margin: '0 0 4px' }}>Grow together. Succeed together.</p>
                        <p style={{ color: '#ddd', fontSize: '16px', margin: '0 0 16px' }}>Build lasting partnerships for a stronger tomorrow.</p>

                        {/* Earn Badge - Small */}
                        <div style={{
                            background: 'linear-gradient(90deg, #1e9d4f 0%, #27b85c 100%)',
                            borderRadius: '8px',
                            padding: '8px 14px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '10px',
                            marginBottom: '28px',
                        }}>
                            <span style={{ fontSize: '16px' }}>💰</span>
                            <div>
                                <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '11px', margin: '0 0 1px' }}>
                                    Become a financial advisor with us &amp;
                                </p>
                                <p style={{ color: '#fff', fontSize: '15px', fontWeight: '700', margin: 0 }}>
                                    Earn ₹1 Lakh
                                    <span style={{ fontSize: '12px', fontWeight: '400' }}>/month</span>
                                </p>
                            </div>
                        </div>

                        {/* Icons */}
                        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                            {icons.map((item, index) => (
                                <div key={index} style={{ textAlign: 'center' }}>
                                    <div style={{
                                        width: '70px', height: '70px', borderRadius: '50%',
                                        backgroundColor: '#6c47d9', display: 'flex',
                                        alignItems: 'center', justifyContent: 'center',
                                        fontSize: '28px', marginBottom: '10px',
                                    }}>{item.icon}</div>
                                    <p style={{ color: '#fff', fontSize: '13px', margin: 0, lineHeight: '1.4' }}>
                                        {item.label1}<br />{item.label2}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JoinPartnerBanner;